// extracted by mini-css-extract-plugin
export default {"loading-spinner":"ShowScream_loading-spinner__4GCtw"};